import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import EpisodesPage from "@/pages/episodes/page";
import EpisodeDetailPage from "@/pages/episode/page";
import CharactersPage from "@/pages/characters/page";
import CharacterDetailPage from "@/pages/character/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news-detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "episodes", element: <EpisodesPage /> },
      { path: "episode/:id", element: <EpisodeDetailPage /> },
      { path: "characters", element: <CharactersPage /> },
      { path: "character/:id", element: <CharacterDetailPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;